import { useState } from "react";

type Props = {
  codigo: string;
};

const UserCode = ({ codigo }: Props) => {
  const [mostrar, setMostrar] = useState(false);

  return (
    <div className="user-code-container">
      <span className="user-label">ID:</span>

      <span className={`user-number ${!mostrar ? "blurred" : ""}`}>
        {codigo}
      </span>

      <button
        className="eye-btn"
        onClick={() => setMostrar(!mostrar)}
        type="button"
      >
        {mostrar ? "🙈" : "👁️"}
      </button>
    </div>
  );
};

export default UserCode;